import { render, staticRenderFns } from "./chatInput.vue?vue&type=template&id=a24289b0&"
import script from "./chatInput.vue?vue&type=script&lang=js&"
export * from "./chatInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a24289b0')) {
      api.createRecord('a24289b0', component.options)
    } else {
      api.reload('a24289b0', component.options)
    }
    module.hot.accept("./chatInput.vue?vue&type=template&id=a24289b0&", function () {
      api.rerender('a24289b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/fission/detail/chatInput.vue"
export default component.exports